import React, {useState, useEffect, useRef} from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import {notifyUser} from "../../../util/util";
import {serverRequest} from "../../../util/server_request";
import {Spin} from "antd";

export const OneTimePinFP = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const backendPhone = location.state?.phone;
    // For display: 0XXXXXXXXX
    const displayPhone = backendPhone && backendPhone.startsWith('233')
        ? '0' + backendPhone.slice(3).replace(/^0+/, '')
        : backendPhone;

    // Mask phone number for display (e.g., 05****8725)
    const maskPhone = (phone) => {
        if (!phone || phone.length < 6) return phone;
        return phone.slice(0, 2) + '****' + phone.slice(-4);
    };
    const maskedPhone = maskPhone(displayPhone);

    const [otp, setOTP] = useState('')
    const [loading, setLoading] = useState(false)
    const [countdown, setCountdown] = useState(60);
    const [canResend, setCanResend] = useState(false);

    const toggleLoading = () => setLoading(prevState => !prevState)

    const changeHandler = (e) => setOTP(e.target.value)

    const sentRef = useRef(false);

    useEffect(() => {
        if (!sentRef.current) {
            sentRef.current = true;
            rerTriggerOTP(backendPhone);
        }
    }, [])

    useEffect(() => {
        let timer;
        if (countdown > 0) {
            timer = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);
        } else {
            setCanResend(true);
        }
        return () => clearInterval(timer);
    }, [countdown]);

    const verifyOTP = () => {
        if (otp === '' || otp === null){
            return notifyUser('error', 'Please enter OTP received to proceed!', 'Validation Error');
        }
        toggleLoading()
        serverRequest('GET', `auth/verify/phone/otp?otp=${otp}&phone=${backendPhone}`)
            .then(result =>{
                toggleLoading()
                if (!result?.success){
                    notifyUser('error', result?.message, 'Error')
                }else{
                    navigate('/forgot-password/verify-account-pin', {state: {phone: backendPhone, otp}})
                }
            }).catch(error => {
            toggleLoading()
            notifyUser('error', error, 'Error')
        })
    }

    const rerTriggerOTP = (phoneNumber) => {
        toggleLoading()
        serverRequest('POST', 'auth/phone-verification/otp/send', {phone: phoneNumber})
            .then(result => {
                toggleLoading()
                setCountdown(60);
                setCanResend(false);
                if (result?.code === '400'){
                    notifyUser('success', result.message, 'OTP')
                }else{
                    notifyUser('success', `OTP sent to ${phoneNumber}`, 'OTP')
                }
            }).catch(error => {
            toggleLoading()
            notifyUser('error', error, 'Validation Error')
        })
    }


    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Enter your One Time Pin</p>
                <small className='text-center'>We've sent a One-Time Pin(OTP) to this number <strong>{maskedPhone}</strong>.</small>

                <Spin spinning={loading}>
                    <div className="mt-4 w-75 mx-auto mobile-full-width">
                        <omk-otp-field
                            number-of-inputs="6"
                            resend-text=""
                            resend-button-label=""
                            label="One-time Password"
                            className='mb-2' value={otp} onInput={changeHandler} />
                        <p className='mb-0' style={{cursor: 'pointer', paddingBottom: '10px'}} onClick={canResend ? () => rerTriggerOTP(backendPhone) : undefined}>
                          {canResend ? (
                            <span>Didn't receive OTP? <span style={{color: '#009677', fontWeight: 'bold'}}>Resend</span></span>
                          ) : (
                            <span className='text-muted'>Resend OTP in <span style={{fontWeight: 'bold', color: '#009677'}}>{countdown}s</span></span>
                          )}
                        </p>


                        <p className="text-center omk-text-small text-black-50 mb-5"><i className="bi bi-shield-lock"/> Your information is confidential and secure</p>
                        <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={verifyOTP}>Continue</button>
                        <p className="text-center mt-3">
                            <a href="/onboard/login" className="fw-bold text-decoration-underline" style={{ color: '#009677' }}>
                                Back to Login
                            </a>
                        </p>
                    </div>
                </Spin>
            </div>
        </div>
    )
}